export function index() {
  return absolute([]);
}

export function auth(provider: string) {
  return absolute(["app", "auth", provider]);
}

export function app() {
  return absolute(["app"]);
}

export function organizationNew() {
  return absolute(["organization", "new"]);
}

export function project(projectId: string) {
  return absolute(["app", "projects", projectId]);
}

export function projectDocPdf(projectId: string, docId: string) {
  return absolute(["app", "projects", projectId, "doc", docId, "pdf"]);
}

export function projectGetUploadUrl(projectId: string) {
  return absolute(["app", "projects", projectId, "getUploadUrl"]);
}

export function projectDoc(docId: string) {
  return relative([], { docId });
}

export function projectDocMetadata(projectId: string, docId: string) {
  return absolute(["app", "projects", projectId, "doc", docId, "metadata"]);
}

export function projectNew() {
  return absolute(["app", "projects", "new"]);
}

export function projectTopicNew(projectId: string) {
  return absolute(["app", "projects", projectId, "topics", "new"]);
}

export function projectTopic(projectId: string, topicId: string) {
  return absolute(["app", "projects", projectId, "topics", topicId]);
}

export function projectAnswerStream(
  id: string,
  topicId: string,
  question: string,
  deepSearch?: boolean
) {
  const encodedQuestion = encodeURIComponent(question);
  const queryParams: Record<string, string | number | boolean> = {
    question: encodedQuestion,
  };

  if (deepSearch) {
    queryParams.deepSearch = true;
  }

  return absolute(
    ["app", "projects", id, "topics", topicId, "stream"],
    queryParams
  );
}

export function logout() {
  return absolute(["logout"]);
}

/**
 * Constructs a relative URL from the given path segments and query parameters.
 *
 * @param pathSegments - An array of strings representing the path segments to be joined.
 * @param queryParams - An object where keys and values represent the query parameters to be appended.
 * @returns A string representing the constructed URL.
 */
export const relative = (
  pathSegments: string[] = [],
  queryParams: Record<string, string | number | boolean> = {}
): string => {
  const path = pathSegments
    .map((segment) => encodeURIComponent(segment))
    .join("/");

  const queryString = Object.entries(queryParams)
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`
    )
    .join("&");

  const url = `${path}${queryString ? "?" + queryString : ""}`;

  return url;
};

/**
 * Constructs an absolute URL from the given path segments and query parameters.
 *
 * @param pathSegments - An array of strings representing the path segments to be joined.
 * @param queryParams - An object where keys and values represent the query parameters to be appended.
 * @returns A string representing the constructed URL.
 */
export const absolute = (
  pathSegments: string[] = [],
  queryParams: Record<string, string | number | boolean> = {}
): string => {
  return `/${relative(pathSegments, queryParams)}`;
};
